import { ExceptionEnum } from '../enums/ExceptionEnum';
import { errorsCode } from '../utils/consts/errorsCode';

export class ResponseError extends Error {
  constructor(
    public code: keyof typeof errorsCode,
    public message: string,
    public name: ExceptionEnum,
    public statusCode: number,
    public timestamp: Date,
    public details?: unknown,
  ) {
    super(message);
    this.name = name;
    this.code = code;
    this.statusCode = statusCode;
    this.timestamp = timestamp;
    this.details = details;
  }
}
